<template>
  <a-config-provider :locale="locale">
    <a-spin v-if="loadingShow" class="common-loading dflex flexCenter"></a-spin>
    <router-view />
  </a-config-provider>
</template>
<script>
import ja_JP from "ant-design-vue/es/locale/ja_JP";
import store from "@/store";
import { computed, markRaw } from "@vue/reactivity";
export default {
  setup() {
    const locale = markRaw(ja_JP);
    const loadingShow = computed(() => {
      return store.getters.loadingShow;
    });
    return { locale, loadingShow };
  },
  data() {
    return {
      locale: ja_JP,
    };
  },
};
</script>

<style lang="less"></style>
